import { updateUserTag } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useUpdateUserTag = () => {
    const { callAPI, loading } = useWorkspaceApiCall(updateUserTag, '', 'updateUserTag.error');

    return { updateUserTag: callAPI, updatingUserTag: loading };
}